import PropTypes from 'prop-types';
import EmailTemplateCard from './email-template-card';
import EmptyStateMessage from 'components/lists/empty-state-message';

const SearchResultsList = ({ searchResults, searchTerm, selectedTemplate, openTemplateForm }) => {
  if (!searchResults || searchResults.length === 0) {
    return <EmptyStateMessage text={`No templates found matching "${searchTerm}"`} />;
  }

  return (
    <>
      {searchResults.map((template) =>
        template && template.id ? (
          <EmailTemplateCard
            key={template.id}
            template={template}
            selectedTemplate={selectedTemplate}
            openTemplateForm={openTemplateForm}
          />
        ) : null
      )}
    </>
  );
};

SearchResultsList.propTypes = {
  searchResults: PropTypes.array,
  searchTerm: PropTypes.string,
  selectedTemplate: PropTypes.object,
  openTemplateForm: PropTypes.func.isRequired,
};

export default SearchResultsList;
